import { ACT_TAG_CHANGE } from "./ActionTypes";
import TagService from "../provider/tag/TagService";
import {loading} from "./AppActions"

export function actionSaveTag(tag, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    console.log("TAG", tag)
      TagService.saveTag(getStore().app.app, tag).then((response) => {
        successCallback&&successCallback(response)
      }).catch(errorCallback)
  };
}

export function actionGetTags(succesCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      TagService.getTags(getStore().app.app).then((response) => {
          dispatch({
            type:ACT_TAG_CHANGE,
            props: {tagList:response}
          })
          succesCallback&&succesCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}


export function actionDeleteTag(tag, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
      TagService.deleteTag(getStore().app.app, tag).then((response) => {
        successCallback&&successCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})

  };
}

export function actionDeleteTagFromUser(tag, user, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)

    console.log("actionDeleteTagFromUser", tag, user)
      TagService.deleteTagFromUser(getStore().app.app, tag, user).then((response) => {
        successCallback&&successCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})

  };
}


// WEBPACK FOOTER //
// ./src/actions/TagActions.js